import { render } from "./SpendByCustomerTagPage.vue?vue&type=template&id=4cfbfda4&scoped=true"
import script from "./SpendByCustomerTagPage.vue?vue&type=script&lang=js"
export * from "./SpendByCustomerTagPage.vue?vue&type=script&lang=js"

import "./SpendByCustomerTagPage.vue?vue&type=style&index=0&id=4cfbfda4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cfbfda4"]])

export default __exports__